import { Steps } from '../../../../ui/layouts/OnboardingLayout';

export function Stepper({
  currentStep,
  totalSteps,
}: {
  currentStep: Steps;
  totalSteps?: number;
}) {
  const stepNames = Object.keys(Steps).filter((key) => isNaN(Number(key)));
  const visibleSteps =
    typeof totalSteps === 'number' ? stepNames.slice(0, totalSteps) : stepNames;

  return (
    <div className="mt-8 flex items-center justify-center gap-3">
      {visibleSteps.map((_, index) => (
        <div
          key={index}
          className={`h-2 flex-1 rounded-full transition-all duration-300 ${
            index === currentStep
              ? 'bg-[#15803D]'
              : index < currentStep
              ? 'bg-[#15803D]'
              : 'bg-[#DCFCE7]'
          }`}
        ></div>
      ))}
    </div>
  );
}
